import { ICommonDropdownOption } from 'pg-ui-library';

export const dropdownOptions1: ICommonDropdownOption[] = [
  {
    key: '1',
    label: 'Active Employee',
    value: '1',
  },
  {
    key: '2',
    label: 'Inactive Employee',
    value: '0',
  },
  {
    key: '3',
    label: 'Both',
    value: '2',
  },
];
